// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"SubCategoryCard_card-wrapper__O69zx","sub-category-card":"SubCategoryCard_sub-category-card__4Ygc6","bg":"SubCategoryCard_bg__Bf6Cz"};